(function ($) {
  $(".input-mask").mask("+38 (000) 00-00-000");
})(jQuery);
